export const Mode = {
  RIGID_BODY: 0,
  SIMILARITY: 1,
  AFFINE: 2,
};

export default {
  Mode,
};
